// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25XN_","title":"styles_title__j_1lc"};